import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.hanscribe.encounters');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-hanscribe-encounters',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.hanscribe.encounters/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
  background: #f2f1ec;
}`],
})
export class PageHanscribeEncountersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.allow("/access")) return;
        await this.service.render();
    }
}

export default PageHanscribeEncountersComponent;